import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired feature (influencer programme): old links go somewhere useful. Data is kept.
export const Route = createFileRoute("/admin/influencers")({
  beforeLoad: () => {
    throw redirect({ to: "/admin", replace: true, statusCode: 301 });
  },
});
